import React from 'react';
// import moment from 'moment';

import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  invoice__date: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  section__first: {
    alignItems: 'flex-start',
    maxWidth: '25%',
  },
  gray__text__heading: {
    fontSize: 8,
    fontFamily: 'Roboto',
    fontWeight: '600',
    marginBottom: 7,
    marginTop: 12,
  },
  gray__small__text: {
    lineHeight: 2,
    fontSize: 7,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  section: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
    alignItems: 'center',
  },
  section__up: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
  },

  mt__20: {
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  invoice__date__Left: {
    borderRadius: '5px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 4,
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },

  gray__text: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
  },

  gray__text_up: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },

  mr1: {
    flexGrow: 1,
    alignItems: 'flex-start',
    borderRight: '1px solid #8A9EAF',
    paddingTop: 6,
    paddingBottom: 6,
  },
  mr__l: {
    flexGrow: 1,
    alignItems: 'flex-start',
    paddingTop: 6,
    paddingBottom: 6,
  },
  font__bold: {
    fontWeight: 'bold',
  },
});

export default function Information({ data }) {
  const {
    customer = '',
    vehicle = '',
    visitType = '',
    mileageIn = '',
    mileageInType = '',
    serviceAdvisor = '',
    // estimate = '',
  } = data || '';
  const { name = '', phone = '', email = '', address = '' } = customer || '';
  const {
    vehicleMake = '',
    vehicleModel = '',
    modelYear = '',
    licensePlate = '',
    vin = '',
    displacement = '',
    engineDisplacementType = '',
    vehicleType = '',
  } = vehicle || '';

  return (
    <>
      <View style={styles.invoice__date}>
        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Customer Info:</Text>
          <Text style={styles.gray__small__text}>{name}</Text>
          <Text style={styles.gray__small__text}>{phone}</Text>
          <Text style={styles.gray__small__text}>{email}</Text>
          <Text style={styles.gray__small__text}>{address}</Text>
        </View>

        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Vehicle Info:</Text>
          <Text style={styles.gray__small__text}>
            {modelYear} {vehicleMake} {vehicleModel}
          </Text>
          <Text style={styles.gray__small__text}>
            <span style={styles.font__bold}>License Plate:</span>
            {licensePlate}
          </Text>
          <Text style={styles.gray__small__text}>VIN: {vin}</Text>
          <Text style={styles.gray__small__text}>
            {displacement} {engineDisplacementType}
          </Text>
          <Text style={styles.gray__small__text}>{vehicleType}</Text>
        </View>

        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Visit Type:</Text>
          <Text style={styles.gray__small__text}>
            {' '}
            {visitType === 'stayWithVehicle'
              ? 'Stay With Vehicle'
              : visitType === 'dropOff'
              ? 'Drop Off'
              : null}
          </Text>
        </View>

        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Service Advisor:</Text>
          <Text style={styles.gray__small__text}>{serviceAdvisor?.name}</Text>
        </View>

        <View style={styles.section__first}>
          <Text style={styles.gray__text__heading}>Mileage In:</Text>
          <Text style={styles.gray__small__text}>
            {mileageIn}{' '}
            {mileageInType === 'KPH'
              ? 'KM'
              : mileageInType === 'MPH'
              ? 'Miles'
              : ''}
          </Text>
        </View>
      </View>
      <View style={styles.mt__20}>
        <View style={styles.invoice__date__Left}>
          {/* <View>
            <View style={styles.section__up}>
              <Text style={styles.gray__text_up}>Estimate Date</Text>
            </View>
            <View style={styles.section__up}>
              <Text style={styles.gray__text}>
                {estimate?.createdAt
                  ? moment(estimate.createdAt).format('MM/DD/YYYY')
                  : ''}
              </Text>
            </View>
          </View> */}

          {/* <View style={styles.mr1}>
            <View style={styles.section__up}>
              <Text style={styles.gray__text_up}>Proposed Completion Date</Text>
            </View>
            <View style={styles.section__up}>
              <Text style={styles.gray__text}>
                {estimate?.proposedDate
                  ? moment(estimate.proposedDate).format('MM/DD/YYYY')
                  : ''}
              </Text>
            </View>
          </View>

          <View style={styles.mr__l}>
            <View style={styles.section__up}>
              <Text style={styles.gray__text_up}>Proposed Completion Time</Text>
            </View>
            <View style={styles.section__up}>
              <Text style={styles.gray__text}>
                {estimate?.proposedTime
                  ? estimate?.proposedTime?.split('-')?.[1] || ''
                  : ''}
              </Text>
            </View>
          </View> */}
        </View>
      </View>
    </>
  );
}
